import apiHelper from '../utils/apiHelper';

const handleApiError = (error, customMessage) => {
    console.error('🚨 MediaService API Error:', { error, customMessage });
    
    let errorMessage;
    
    if (error?.response?.data?.details) {
        errorMessage = error.response.data.details;
    } else if (error?.response?.data?.error) {
        errorMessage = error.response.data.error;
    } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
    } else if (error?.message) {
        errorMessage = error.message;
    } else if (typeof error === 'string') {
        errorMessage = error;
    } else {
        errorMessage = customMessage || 'An unknown error occurred';
    }
    
    console.error('📋 Final error message:', errorMessage);
    return errorMessage;
};

/**
 * Get SharePoint choice field options (no caching for real-time updates)
 */
const getChoiceFieldOptions = async () => {
    try {
       
        const response = await apiHelper.get('/api/graph/media-center/choice-fields');
        
       
        return response.data;
        
    } catch (error) {
        const errorMessage = handleApiError(error, 'Failed to fetch choice field options');
        console.error('Error in getChoiceFieldOptions:', errorMessage);
        
        throw new Error(`Failed to load choice fields from SharePoint: ${errorMessage}`);
    }
};

/**
 * Get all Media Centre items to check for duplicates
 */
const getMediaCentreItems = async () => {
    try {
       
        const response = await apiHelper.get('/api/graph/media-center/items');
        
       
        return response.data || [];
        
    } catch (error) {
        const errorMessage = handleApiError(error, 'Failed to fetch Media Centre items');
        console.error('Error in getMediaCentreItems:', errorMessage);
        
        // Don't throw error - just return empty array so duplicate check fails gracefully
        console.warn('⚠️ Returning empty array for duplicate check');
        return [];
    }
};

/**
 * Send media item to Media Centre (save to blob + SharePoint)
 */
const sendToMediaCentre = async (mediaData) => {
    try {
       
        
        const response = await apiHelper.post('/api/graph/media-center/publish', mediaData);
        
       
        return response.data;
        
    } catch (error) {
        const errorMessage = handleApiError(error, 'Failed to send media to Media Centre');
        console.error('Error in sendToMediaCentre:', errorMessage);
        throw new Error(errorMessage);
    }
};

/**
 * Update an existing Media Centre item
 */
const updateMediaCentreItem = async (itemId, mediaData) => {
    try {
       
        
        const response = await apiHelper.put(`/api/graph/media-center/items/${itemId}`, mediaData);
        
        
        return response.data;
        
    } catch (error) {
        const errorMessage = handleApiError(error, 'Failed to update Media Centre item');
        console.error('Error in updateMediaCentreItem:', errorMessage);
        throw new Error(errorMessage);
    }
};

export {
    getChoiceFieldOptions,
    getMediaCentreItems,
    sendToMediaCentre,
    updateMediaCentreItem
}; 